const INTERNAL_DOMAIN = "advoc8.co";

function isIgnoredHref(href) {
  return href.startsWith("#") || href.startsWith("javascript:") || href.startsWith("/");
}

function isInternalUrl(href) {
  try {
    const url = new URL(href, window.location.origin);
    return (
      url.host === window.location.host ||
      url.host === INTERNAL_DOMAIN ||
      url.host.endsWith("." + INTERNAL_DOMAIN)
    );
  } catch (error) {
    return true;
  }
}

$(document).on("click", "a[href]", function () {
  const $link = $(this);
  const href = $link.attr("href");

  if ($link.data("ignore-external-url") !== undefined || !href) { return; }
  if (isIgnoredHref(href) || isInternalUrl(href)) { return; }

  return confirm("Notice: You are being directed to an external site: \n" + href);
});
